import React, { useEffect, useState, useRef } from 'react';
import './../calendar.css';

function DayViewCalendar(props) {
    const [daySlots, setDaySlots] = useState([]);

    const tableContentRef = useRef(null);

    useEffect(() => {
        generateDaySlots();
    }, [props.day]);
    const handleScroll = () => {
        const tableContentElement = tableContentRef.current;
        if (tableContentElement.scrollTop + tableContentElement.clientHeight >= tableContentElement.scrollHeight) {
            // Scrolled to the bottom, load more items
            loadMoreItems();
        }
    };

    useEffect(() => {
        // Attach scroll event listener to table content
        const tableContentElement = tableContentRef.current;
        tableContentElement.addEventListener('scroll', handleScroll);

        // Cleanup function
        return () => {
            tableContentElement.removeEventListener('scroll', handleScroll);
        };
    }, []);



    const loadMoreItems = () => {
        // Your logic to load more items
        // For example, fetch data from an API and append to daySlots
    };


    const generateDaySlots = () => {
        const currentDay = new Date(props.day);

        let timeSlots = [];
        for (let i = 0; i < 24; i++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const currentTime = new Date(currentDay);
                currentTime.setHours(i);
                currentTime.setMinutes(minute);
                const formattedTime = currentTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

                const appointments = props.appointments.filter(appointment => {
                    const appointmentDate = new Date(appointment.book_date);
                    return (
                        appointmentDate.getDate() === currentDay.getDate() &&
                        appointmentDate.getMonth() === currentDay.getMonth() &&
                        appointmentDate.getFullYear() === currentDay.getFullYear() &&
                        appointment.book_time === formattedTime
                    );
                });

                let bookItems = [];
                appointments.forEach(appointment => {
                    let items = JSON.parse(appointment.book_items);
                    bookItems.push(...items);
                });

                timeSlots.push({
                    time: formattedTime,
                    appointments: appointments,
                    bookItems: bookItems
                });
            }
        }

        setDaySlots(timeSlots);
    };
    console.log(daySlots);

    const handleTimeSlotClick = (index, time) => {
        // Handle time slot click
    };

    return (
        <div className="day-calendar d-flex">
            {/* Render time slots */}
            <div className="time-slots">
                {/* <div className="time-slot-label"></div> */}
                <ul>
                    {[...Array(24)].map((_, index) => {
                        const formattedTime = new Date(2000, 0, 1, index, 0).toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                        return <li key={index}>{formattedTime}</li>;
                    })}
                </ul>
            </div>
            {/* Render day slots */}
            <div className="table-content" ref={tableContentRef}>
                {daySlots.map((timeSlot, index) => (
                    <div key={index} className="time-slot">
                        <div className={timeSlot.appointments.length > 0 ? "appointment-info" : ""}>
                            {timeSlot.appointments.map(appointment => (
                                <div key={appointment.id} className="appointment">
                                    {/* <p>{appointment.book_time}</p> */}
                                    <p className='text-capitalize'>{appointment.firstName} {appointment.lastName}</p>
                                    {timeSlot.bookItems.map((bookItem, index) => (
                                        <div key={bookItem.id} className="book-item">
                                            <p>{bookItem.name}{index < timeSlot.bookItems.length - 1 && ', '} </p>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DayViewCalendar;